import React from "react";
import parse from 'html-react-parser';

const VideoEmbed = ({ embed }) => {
	return (
		<div className="VideoEmbed-root">
			{parse(embed)}
		</div>
	)
}

export default VideoEmbed;